var noopTheme={};export default noopTheme;